import { FC } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { hideTrialExpiredDialogAction } from '../../store/trialExpired'
import { TrialExpiredDialog } from './TrialExpiredDialog'

const TrialExpiredDialogHost: FC = () => {
  const dispatch = useAppDispatch()
  const { open } = useAppSelector((state) => state.trialExpiredDialog)

  const onClose = () => dispatch(hideTrialExpiredDialogAction())

  return <TrialExpiredDialog open={open} onClose={onClose} />
}

export default TrialExpiredDialogHost
